import { render, staticRenderFns } from "./ZoneVisitWhiteListPage.vue?vue&type=template&id=205f3b20"
import script from "./ZoneVisitWhiteListPage.vue?vue&type=script&lang=js"
export * from "./ZoneVisitWhiteListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports